import { render } from "./MessageImportPage.vue?vue&type=template&id=3090c0ff"
import script from "./MessageImportPage.vue?vue&type=script&lang=js"
export * from "./MessageImportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__